import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useAdmin } from '../../contexts/AdminContext'
import { useNavigate } from 'react-router-dom'
import { useUsers } from '../../contexts/UsersContext'
import { useEffect, useState } from 'react'

const OrdersFeed = () => {
  const { quotes } = useAdmin()
  const navigate = useNavigate()
  const { loggedOnUser } = useUsers()
  const [citiesOffered, setCitiesOffered] = useState([])
  const [servicesOffered, setServicesOffered] = useState([])
  const [filteredQuotes, setFilteredQuotes] = useState([])

  useEffect(() => {
    if (loggedOnUser) {
      if (loggedOnUser.role === 'business') {
        setCitiesOffered(loggedOnUser.citiesOffered)
        setServicesOffered(loggedOnUser.servicesOffered)
        setFilteredQuotes(quotes)
      }
    }
  }, [loggedOnUser, quotes])
  console.log('citiesOffered', citiesOffered)
  console.log('servicesOffered', servicesOffered)
  console.log('quotes', quotes)
  console.log('filteredQuotes', filteredQuotes)

  return (
    <div className='item ob-item'>
      <div className='ob-head'>
        <h3>Potential Orders</h3>
        <span
          onClick={() => alert('Navigate to All quotes Page')}
          style={{
            color: '#1d1d55',
            fontFamily: 'Jost',
            cursor: 'pointer',
          }}
        >
          View all
        </span>
      </div>
      <Form.Select
        className='my-select'
        defaultValue={'AAA'}
        onChange={(e) => {
          e.target.value === ''
            ? setFilteredQuotes(quotes && quotes)
            : setFilteredQuotes(
                quotes &&
                  quotes.filter(
                    (quote) => quote.address.post_town === e.target.value
                  )
              )
        }}
      >
        <option value='AAA'>Select City</option>
        {citiesOffered &&
          citiesOffered.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        <option value=''>All over UK</option>
      </Form.Select>
      <Form.Control
        as='select'
        className='my-select'
        defaultValue={'AAA'}
        onChange={(e) => {
          e.target.value === ''
            ? setFilteredQuotes(quotes && quotes)
            : setFilteredQuotes(
                quotes &&
                  quotes.filter(
                    (quote) => quote.categoryNeeded === e.target.value
                  )
              )
        }}
      >
        <option value='AAA'>Select category</option>
        {servicesOffered &&
          servicesOffered.map((service) => (
            <option key={service} value={service}>
              {service}
            </option>
          ))}
        <option value=''>All categories</option>
      </Form.Control>

      {filteredQuotes &&
        filteredQuotes.map((quote) => (
          <div key={quote.id}>
            <Card border='primary'>
              <Card.Body border='primary' align='left'>
                <Row>
                  <Col sm={10}>
                    <p className='my-p1'>
                      Date Created: {quote && quote.created}
                      <br />
                      Description: {quote.serviceNeeded}
                      <br />
                      Category: {quote.categoryNeeded}
                      <br />
                      Location: {quote.address.post_town}
                      <br />
                      Status:{' '}
                      <b
                        style={{
                          color:
                            quote.status === 'Completed'
                              ? 'green'
                              : quote.status === 'Pending'
                              ? 'red'
                              : 'blue',
                        }}
                      >
                        {' '}
                        {quote.status}
                      </b>
                    </p>
                  </Col>
                  <Col sm={1}>
                    <br />
                    <br />
                    <i
                      onClick={() =>
                        navigate(`/business/quotes/${quote.id}`, {
                          state: { quote },
                        })
                      }
                      className='las la-angle-right'
                      style={{
                        fontSize: '24px',
                        color: '#1D1D55',
                        cursor: 'pointer',
                      }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        ))}
    </div>
  )
}

export default OrdersFeed
